/*!
  * Owl v1.0.0 (git@bitbucket.org:devasghar/owl.git)
  */
/**
 * @file
 * Global utilities.
 *
 */
(function ($, Drupal) {

    'use strict';

    Drupal.behaviors.ncm = {
        attach: function (context, settings) {
            Drupal.behaviors.ncm.initTheme();
            Drupal.behaviors.ncm.setHeight();
            Drupal.behaviors.ncm.scrollReveal();
            Drupal.behaviors.ncm.ncmAdjustFloatingDivs();
            Drupal.behaviors.ncm.ncmTypeWrite();
            Drupal.behaviors.ncm.circleSlider();
            Drupal.behaviors.ncm.selectionStylings();
            Drupal.behaviors.ncm.carouselSlider();
            Drupal.behaviors.ncm.general();
            Drupal.behaviors.ncm.counterOnScroll();
            Drupal.behaviors.ncm.agpSearchSubmission();
            Drupal.behaviors.ncm.nodeQuickLinks();
            Drupal.behaviors.ncm.nodeQuickLinksScroll();
        }
    };

    /**
     * Search submission
     */
    Drupal.behaviors.ncm.agpSearchSubmission = function (context, settings) {
        var submitButton = $(".search-block-form #edit-submit--2", context).once(),
            textInput = $(".search-block-form #edit-keys", context).once(),
            searchRegion = $(".block-region-search", context).once();

        submitButton.on('click', function (e) {
            if (textInput.val() === "") {
                e.preventDefault();
                searchRegion.toggleClass('reveal');
                textInput.toggleClass('show').focus();
            }
        });
    };

    Drupal.behaviors.ncm.scrollReveal = function (context, settings) {
        ScrollReveal().reveal('.reveal-on-scroll', {delay: 150});
    };

    /**
     * Floating div position adjustments
     * @type {{attach: Drupal.behaviors.footer_links.attach}}
     */
    Drupal.behaviors.ncm.ncmAdjustFloatingDivs = function (context, settings) {
        var floatingBlocks = $(".floating", context);
        $.each(floatingBlocks, function (key, floatingBlock) {
            var nextToFloatingBlocks = [],
                prevToFloatingBlocks = [],
                nextColVal = 0,
                prevColVal = 0;

            $.each($(this).nextAll(), function (index, val) {
                nextColVal += $(val).getColVal();
                nextToFloatingBlocks.push(val);
                if (nextColVal === 12) {
                    return false;
                }
            });

            $.each($(this).prevAll(), function (index, val) {
                prevColVal += $(val).getColVal();
                prevToFloatingBlocks.push(val);
                if (prevColVal === 12) {
                    return false;
                }
            });


            // Resetting adjustments
            $(this).css({
                'margin-top': '0',
                'height': 'auto',
            });

            $.each(nextToFloatingBlocks, function (index, value) {
                $(value).css({
                    'margin-top': '0',
                    'padding-top': '0'
                });
            });

            $.each(prevToFloatingBlocks, function (index, value) {
                $(value).css({
                    'padding-bottom': '0'
                });
            });


            // Calculating the new height
            var floatingBlockHeight = $(this).height();

            // Applying it
            $(this).css({
                'margin-top': -floatingBlockHeight / 2,
                'height': floatingBlockHeight
            });

            $.each(nextToFloatingBlocks, function (index, value) {
                $(value).css({
                    'margin-top': -floatingBlockHeight / 2,
                    'padding-top': floatingBlockHeight / 2
                });
            });

            $.each(prevToFloatingBlocks, function (index, value) {
                $(value).css({
                    'padding-bottom': floatingBlockHeight / 2
                });
            });
        });
    };

    Drupal.behaviors.ncm.ncmTypeWrite = function (context, settings) {
        var TxtType = function (el, toRotate, period) {
            this.toRotate = toRotate;
            this.el = el;
            this.loopNum = 0;
            this.period = parseInt(period, 10) || 2000;
            this.txt = '';
            this.tick();
            this.isDeleting = false;
        };

        Drupal.behaviors.ncm.circleSlider = function (context, settings) {
            let i = 2;
            var radius = 100;
            var fields = $('.itemDot');
            var container = $('.dotCircle');
            var width = container.width();
            radius = width / 2.5;

            var height = container.height();
            var angle = 0, step = (2 * Math.PI) / fields.length;
            fields.each(function () {
                var x = Math.round(width / 2 + radius * Math.cos(angle) - $(this).width() / 2);
                var y = Math.round(height / 2 + radius * Math.sin(angle) - $(this).height() / 2);
                $(this).css({
                    left: x + 'px',
                    top: y + 'px'
                });
                angle += step;
            });


            fields.click(function () {

                var dataTab = $(this).data("tab");
                fields.removeClass('active');
                $(this).addClass('active');
                $('.CirItem').removeClass('active');
                $('.CirItem' + dataTab).addClass('active');
                i = dataTab;

                container.css({
                    "transform": "rotate(" + (360 - (i - 1) * 36) + "deg)",
                    "transition": "2s"
                });
                fields.css({
                    "transform": "rotate(" + ((i - 1) * 36) + "deg)",
                    "transition": "1s"
                });


            });

            setInterval(function () {
                var dataTab = $('.itemDot.active').data("tab");
                if (dataTab > 6 || i > 6) {
                    dataTab = 1;
                    i = 1;
                }
                fields.removeClass('active');
                $('[data-tab="' + i + '"]').addClass('active');
                $('.CirItem').removeClass('active');
                $('.CirItem' + i).addClass('active');
                i++;


                container.css({
                    "transform": "rotate(" + (360 - (i - 2) * 36) + "deg)",
                    "transition": "2s"
                });
                fields.css({
                    "transform": "rotate(" + ((i - 2) * 36) + "deg)",
                    "transition": "1s"
                });

            }, 75000);
        };

        Drupal.behaviors.ncm.carouselSlider = function (content, settings) {
            $('.ncm-layout--element-carousel.carousel').carousel({
                interval: 7000,
            });
        };

        Drupal.behaviors.ncm.selectionStylings = function (context, settings) {
            var elem = $('.js-webform-select2');
            if (typeof elem !== "undefined") {
                // Get the last class of the element
                var elemLastClass = elem.closest('.ncm--block').attr('class');
                if (typeof elemLastClass !== "undefined") {
                    $(document).ready(function () {
                        $(".select2-selection").on('click', function () {
                            $(".select2-dropdown").addClass(elemLastClass.split(' ').pop());
                        });
                    });
                }
            }
        };

        Drupal.behaviors.ncm.general = function (context, settings) {
            $.each($('.ncm--block--inner'), function (index, value) {
                if ($(this).hasClass('px-0')) {
                    $(this).parent().addClass('px-0')
                }
            });
        };

        /**
         * Counters
         */
        Drupal.behaviors.ncm.counterOnScroll = function (context, settings) {
            var counterFields = $(".field--name-field-counter-number");
            $.each(counterFields, function (key, counterField) {
                $(this).attr("data-counter-to", $(this).text());
                $(this).attr("data-counter", "true");
            });


            $(window).on("scroll", function (e) {
                $.each(counterFields, function (key, counterField) {
                    if ($(this).isInViewport() && $(this).attr("data-counter") === "true") {
                        $(this).attr("data-counter", "false");
                        $(this).countTo({
                            from: 0,
                            to: $(this).attr("data-counter-to"),
                            speed: 1000,
                            refreshInterval: 100,
                        });
                    }
                });
            });

            $.fn.isInViewport = function () {
                var elementTop = $(this).offset().top;
                var elementBottom = elementTop + $(this).outerHeight();
                var viewportTop = $(window).scrollTop();
                var viewportBottom = viewportTop + $(window).height();
                return elementBottom > viewportTop && elementTop < viewportBottom;
            };

            $.fn.countTo = function (options) {
                var loops = Math.ceil(options.speed / options.refreshInterval),
                    increment = (options.to - options.from) / loops;

                return $(this).each(function () {
                    var _this = this,
                        loopCount = 0,
                        value = options.from,
                        interval = setInterval(updateTimer, options.refreshInterval);

                    function updateTimer() {
                        value += increment;
                        loopCount++;
                        $(_this).html(value.toFixed(options.decimals));

                        if (typeof (options.onUpdate) == 'function') {
                            options.onUpdate.call(_this, value);
                        }

                        if (loopCount >= loops) {
                            clearInterval(interval);
                            value = options.to;

                            if (typeof (options.onComplete) == 'function') {
                                options.onComplete.call(_this, value);
                            }
                        }
                    }
                });
            };
        };

        /*
        * Internal Links
        */
        Drupal.behaviors.ncm.nodeQuickLinks = function (context, settings) {
            var headings = $('h2', context).once(),
                elem = $('.quick--links', context).once(),
                linksheading = $('.quick--links-heading', context).once();
            if (headings.length > 0) {
                linksheading.text('Quick Links');
                jQuery.each(headings, function (index, value) {
                    if (typeof $(value).text() !== "undefined" && $(value).text() !== "") {
                        $(this).setId($(value).text());
                        elem.append('<li class="nav-item"><a class="nav-link" href="#' + $(this).getClass($(value).text()) + '">' + $(value).text() + '</a></li>');
                    }
                });
            }
        };

        /*
        * Smooth Scroll on internal links
        */
        Drupal.behaviors.ncm.nodeQuickLinksScroll = function (context, settings) {
            var elem = $('.quick--links li a', context).once();
            $(elem).on('click', function (e) {
                e.preventDefault();
                if ($(window).width() > 991) {
                    $([document.documentElement, document.body]).animate({
                        scrollTop: $($(this).attr('href')).offset().top - 120
                    }, 750);
                } else {
                    $([document.documentElement, document.body]).animate({
                        scrollTop: $($(this).attr('href')).offset().top - 138
                    }, 750);
                }
            })
        };

        TxtType.prototype.tick = function () {
            var i = this.loopNum % this.toRotate.length;
            var fullTxt = this.toRotate[i];

            if (this.isDeleting) {
                this.txt = fullTxt.substring(0, this.txt.length - 1);
            } else {
                this.txt = fullTxt.substring(0, this.txt.length + 1);
            }

            this.el.innerHTML = '<span class="wrap">' + this.txt + '</span>';

            var that = this;
            var delta = 200 - Math.random() * 100;

            if (this.isDeleting) {
                delta /= 2;
            }

            if (!this.isDeleting && this.txt === fullTxt) {
                delta = this.period;
                this.isDeleting = true;
            } else if (this.isDeleting && this.txt === '') {
                this.isDeleting = false;
                this.loopNum++;
                delta = 500;
            }

            setTimeout(function () {
                that.tick();
            }, delta);
        };

        window.onload = function () {
            var elements = document.getElementsByClassName('typewrite');
            for (var i = 0; i < elements.length; i++) {
                var toRotate = elements[i].getAttribute('data-type');
                var period = elements[i].getAttribute('data-period');
                if (toRotate) {
                    new TxtType(elements[i], JSON.parse(toRotate), period);
                }
            }
        };
    }

    Drupal.behaviors.ncm.initTheme = function (context, settings) {
        $('.ncm--night-mode', context).on('click', function () {
            $('html').attr('theme', function (index, attr) {
                trans();
                var date = new Date(),
                    minutes = 30;
                date.setTime(date.getTime() + (minutes * 60 * 1000));
                attr = attr === "dark" ? "light" : "dark";
                $.cookie('theme', attr, {expires: date, path: '/'});
                return attr;
            });
        }).once('initTheme');

        // Automatic switch based on time
        if (typeof $.cookie('theme') === "undefined") {
            var date = new Date(),
                hours = date.getHours(),
                minutes = 30;
            date.setTime(date.getTime() + (minutes * 60 * 1000));
            if (hours > 17 || hours < 7) {
                setTimeout(() => {
                    trans();
                    $('html').attr('theme', 'dark');
                    $.cookie('theme', 'dark', {expires: date, path: '/'});
                }, 5000);
            } else {
                setTimeout(() => {
                    trans();
                    $('html').attr('theme', 'light');
                    $.cookie('theme', 'light', {expires: date, path: '/'});
                }, 5000);
            }
        }
    };

    Drupal.behaviors.ncm.setHeight = function (context, settings) {
        var doc = document.documentElement;
        doc.style.setProperty("--app-height", window.innerHeight + "px");
        window.onresize = function (event) {
            doc.style.setProperty("--app-height", window.innerHeight + "px");
        };
    };

    $.fn.extend({
        getColVal: function () {
            var elem = this.attr('class');
            return parseInt(/col[a-zA-Z-]+([\d]+)/gm.exec(elem).slice(-1)[0]);
        },
        setId: function (label) {
            $(this).attr('id', label.replace(/[^a-z0-9\s]/gi, '').replace(/\s+/g, '-').toLowerCase());
        },
        setClass: function (label) {
            $(this).addClass(label.replace(/[^a-z0-9\s]/gi, '').replace(/\s+/g, '-').toLowerCase());
        },
        getClass: function (label) {
            return label.replace(/[^a-z0-9\s]/gi, '').replace(/\s+/g, '-').toLowerCase();
        },
    });
})(jQuery, Drupal);


function trans() {
    document.documentElement.classList.add('transition');
    window.setTimeout(() => {
        document.documentElement.classList.remove('transition');
    }, 1000);
}
